"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCanvasWorkflow = void 0;
const index_1 = require("../workflow/index");
const getCanvasWorkflow = type => {
  if (type === index_1.WorkflowType.ARRIVAL) {
    return new index_1.CanvasArrivalWorkflow();
  }
  if (type === index_1.WorkflowType.CANCELLATION) {
    return new index_1.CanvasCancellationWorkflow();
  }
  if (type === index_1.WorkflowType.DECLINE) {
    return new index_1.CanvasDeclineWorkflow();
  }
  if (type === index_1.WorkflowType.EVENT_CANCELLATION) {
    return new index_1.CanvasEventCancellationWorkflow();
  }
  if (type === index_1.WorkflowType.INVITATION) {
    return new index_1.CanvasInvitationWorkflow();
  }
  if (type === index_1.WorkflowType.MULTI_REGISTRATION) {
    return new index_1.CanvasMultiRegistrationWorkflow();
  }
  if (type === index_1.WorkflowType.PAYMENT) {
    return new index_1.CanvasPaymentWorkflow();
  }
  if (type === index_1.WorkflowType.PAYMENT_WAITINGLIST) {
    return new index_1.CanvasPaymentWaitinglistWorkflow();
  }
  if (type === index_1.WorkflowType.PRE_ARRIVAL) {
    return new index_1.CanvasPreArrivalWorkflow();
  }
  if (type === index_1.WorkflowType.PROFILE) {
    return new index_1.CanvasProfileWorkflow();
  }
  if (type === index_1.WorkflowType.PUBLIC_REGISTRATION) {
    return new index_1.CanvasPublicRegistrationWorkflow();
  }
  // if (type === WorkflowType.PUBLIC_REGISTRATION_AND_MEMBERSHIP) {
  //     return new CanvasPublicRegistrationAndMembershipWorkflow();
  // }
  if (type === index_1.WorkflowType.REGISTRAION_WAITINGLIST) {
    return new index_1.CanvasRegistrationWaitinglistWorkflow();
  }
  if (type === index_1.WorkflowType.REGISTRATION) {
    return new index_1.CanvasRegistrationWorkflow();
  }
  if (type === index_1.WorkflowType.STAGE_ACTION) {
    return new index_1.CanvasStageActionWorkflow();
  }
  if (type === index_1.WorkflowType.SPLITTER) {
    return new index_1.CanvasSplitterWorkflow();
  }
  if (type === index_1.WorkflowType.SURVEY) {
    return new index_1.CanvasSurveyWorkflow();
  }
  if (type === index_1.WorkflowType.CATEGORY_WAITINGLIST) {
    return new index_1.CanvasCategoryWaitinglistWorkflow();
  }
  // if (type === WorkflowType.WAITINGLIST) {
  //     return new CanvasWaitinglistWorkflow();
  // }
  throw new Error(`type should be: ${JSON.stringify(index_1.WorkflowType)}`);
};
exports.getCanvasWorkflow = getCanvasWorkflow;
